import FeatureCard from "./FeatureCard";

export default FeatureCard;
